import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFullscreen = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-298.67 -348.44 2133.33 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1283 995 928 640 1283 285 1427 429Q1456 460 1497 443Q1536 426 1536 384V-64Q1536 -90 1517.0 -109.0Q1498 -128 1472 -128H1024Q982 -128 965 -88Q948 -49 979 -19L1123 125L768 480L413 125L557 -19Q588 -49 571 -88Q554 -128 512 -128H64Q38 -128 19.0 -109.0Q0 -90 0 -64V384Q0 426 40 443Q79 460 109 429L253 285L608 640L253 995L109 851Q90 832 64 832Q52 832 40 837Q0 854 0 896V1344Q0 1370 19.0 1389.0Q38 1408 64 1408H512Q554 1408 571 1368Q588 1329 557 1299L413 1155L768 800L1123 1155L979 1299Q948 1329 965 1368Q982 1408 1024 1408H1472Q1498 1408 1517.0 1389.0Q1536 1370 1536 1344V896Q1536 854 1497 837Q1484 832 1472 832Q1446 832 1427 851Z"
	})
});
export default SvgFullscreen;
